import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function LearningRemindersToggle() {
  const { t } = useTranslation();
  const { user, refresh } = useAuth();
  const [on, setOn] = useState(user?.learning_reminders_enabled !== false);
  const [saving, setSaving] = useState(false);

  const change = async (v) => {
    setOn(v);
    setSaving(true);
    try {
      await api.put("/streak/reminders", { enabled: v });
      await refresh();
      toast.success(v ? t("learningReminders.on") : t("learningReminders.off"));
    } catch {
      setOn(!v);
      toast.error(t("learningReminders.error"));
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="account-learning-reminders" className="bg-white border border-slate-200 rounded-2xl p-8 flex items-start gap-4">
      <div className="w-10 h-10 rounded-xl bg-amber-100 text-amber-800 flex items-center justify-center shrink-0"><BellRing size={18} /></div>
      <div className="flex-1 min-w-0">
        <div className="text-xs uppercase tracking-widest text-blue-800 font-semibold">{t("learningReminders.title")}</div>
        <p className="mt-2 text-sm text-slate-600 max-w-lg">{t("learningReminders.body")}</p>
      </div>
      <Switch data-testid="account-learning-reminders-switch" checked={on} disabled={saving} onCheckedChange={change} />
    </div>
  );
}
